'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _iterator = require('babel-runtime/core-js/symbol/iterator');

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.debounced = debounced;
exports.throttled = throttled;
exports.microSeconds = microSeconds;
exports.randomToken = randomToken;
exports.isPromise = isPromise;
exports.sleep = sleep;
exports.now = now;
exports.waitUntil = waitUntil;
/**
 * Determine if we are in a browser
 * or a server environment
 * @type {Boolean}
 * @private
 */
var IS_BROWSER = exports.IS_BROWSER = (typeof window === 'undefined' ? 'undefined' : typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object';

/**
 * Default element to listen for events on
 * @type {Object}
 * @private
 */
var DEFAULT_ELEMENT = exports.DEFAULT_ELEMENT = IS_BROWSER ? document : {};

/**
 * The default events to determine activity
 * @type {Array}
 * @private
 */
var DEFAULT_EVENTS = exports.DEFAULT_EVENTS = ['mousemove', 'keydown', 'wheel', 'DOMMouseScroll', 'mousewheel', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown', 'MSPointerMove', 'visibilitychange'];

/**
 * Creates a debounced function that delays invoking func until
 * after delay milliseconds has elapsed since the last time the
 * debounced function was invoked.
 * @name debounced
 * @param  {Function} fn   Function to debounce
 * @param  {Number} delay  How long to wait
 * @return {Function}      Executed Function
 * @private
 **/
function debounced(fn, delay) {
  var timerId = void 0;
  function result() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(function () {
      fn.apply(undefined, args);
      timerId = null;
    }, delay);
  }

  result.cancel = function () {
    clearTimeout(timerId);
  };

  return result;
}

/**
 * Creates a throttled function that only invokes func at most
 * once per every wait milliseconds.
 * @name throttled
 * @param  {Function} fn   Function to debounce
 * @param  {Number} delay  How long to wait
 * @return {Function}      Executed Function
 * @private
 **/
function throttled(fn, delay) {
  var lastCall = 0;
  return function () {
    var now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn.apply(undefined, arguments);
  };
}

var lastMs = 0;
var additional = 0;

/**
 * Returns current time in microseconds.
 *
 * @returns {Number} current time in microseconds
 * @private
 */
function microSeconds() {
  var ms = new Date().getTime();
  if (ms === lastMs) {
    additional++;
    return ms * 1000 + additional;
  } else {
    lastMs = ms;
    additional = 0;
    return ms * 1000;
  }
}

/**
 * Generate and return a random token.
 *
 * @returns {String} Random token.
 * @private
 */
function randomToken() {
  return Math.random().toString(36).substring(2);
}

/**
 * Checks if a js object is a promise.
 *
 * @param {*} obj  Any javascript object.
 * @returns {Boolean} Wether or not this object is a promise.
 */
function isPromise(obj) {
  if (obj && typeof obj.then === 'function') {
    /* istanbul ignore next */
    return true;
  } else {
    return false;
  }
}

/**
 * Sleeps for x amount of milliseconds.
 *
 * @param {Number} time   Amount of time in milliseconds.
 * @returns {Promise}
 * @private
 */
function sleep() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return new _promise2.default(function (resolve) {
    return setTimeout(resolve, time);
  });
}

/**
 * Get the current timestamp.
 *
 * @returns {Number}
 * @private
 */
function now() {
  return new Date().getTime();
}

/**
 * Waits until the given function returns true
 * @param  {function}  fn
 * @return {Promise}
 */
function waitUntil(fn) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

  var timedOut = false;
  var ok = false;

  /* istanbul ignore next */
  if (timeout !== 0) {
    sleep(timeout).then(function () {
      timedOut = true;
    });
  }

  return new _promise2.default(function (resolve, reject) {
    var runLoop = function runLoop() {
      if (ok) {
        resolve();
        return;
      }
      /* istanbul ignore next */
      if (timedOut) {
        reject(new Error('\u274C waitUntil reached timeout of ' + timeout + 'ms'));
        return;
      }
      sleep(interval).then(function () {
        ok = fn();
        runLoop();
      });
    };
    runLoop();
  });
}